import { setRequestFirmId } from "./firm-context";
import { getData } from "./url-request";
import { recordUserActivity } from "./session-activity";

let currentUser = null;
let sessionVersion = 0;

export const getAuthenticatedUser = () => currentUser;
export const setAuthenticatedUser = (user) => {
  currentUser = user || null;
  setRequestFirmId(user?.firmId);
};
export const clearAuthenticatedUser = () => {
  currentUser = null;
  setRequestFirmId(null);
  sessionVersion += 1;
};

export const loadAuthenticatedUser = async () => {
  const version = sessionVersion;
  // Loading a protected application route is an intentional browser action.
  // Expired sessions are rejected before this signal can renew them.
  recordUserActivity({ broadcast: false });
  const response = await getData("/Authenticate/me");
  if (version !== sessionVersion || !response?.status || !response.data) {
    const error = new Error(version !== sessionVersion ? "Session ended" : "Unauthenticated");
    error.status = 401;
    throw error;
  }
  setAuthenticatedUser(response.data);
  return response.data;
};

// Contains no user details, tokens, or authentication state.
const logoutEventKey = "piers.logout-event";
export const broadcastLogout = (reason = "logout") => {
  try {
    localStorage.setItem(
      logoutEventKey,
      `${reason}:${Date.now()}-${Math.random()}`
    );
  } catch {
    /* Storage may be disabled. */
  }
  try {
    const channel = new BroadcastChannel(logoutEventKey);
    channel.postMessage(reason);
    channel.close();
  } catch {
    /* Storage events remain available on older browsers. */
  }
};
export const subscribeToLogout = (onLogout) => {
  const onStorage = (event) => {
    if (event.key === logoutEventKey && event.newValue)
      onLogout(event.newValue.startsWith("expired:") ? "expired" : "logout");
  };
  window.addEventListener("storage", onStorage);
  let channel;
  try {
    channel = new BroadcastChannel(logoutEventKey);
    channel.onmessage = (event) =>
      onLogout(event.data === "expired" ? "expired" : "logout");
  } catch {
    /* Use storage events. */
  }
  return () => {
    window.removeEventListener("storage", onStorage);
    channel?.close();
  };
};
